export default {
  feedbackBlockTitle: {
    id: 'merchant_onboarding_home_feedback_block_title',
    defaultMessage: 'Share your thoughts',
  },
  feedbackBlockDescription: {
    id: 'merchant_onboarding_home_feedback_block_description',
    defaultMessage:
      'What did you think about the onboarding experience? How can we make it better?',
  },
  feedbackBlockButtonLabel: {
    id: 'merchant_onboarding_home_feedback_block_button_label',
    defaultMessage: 'Give feedback',
  },
  feedbackImageAlt: {
    id: 'merchant_onboarding_home_feedback_block_image_alt',
    defaultMessage: 'Share your thoughts',
  },
}
